/**
 * @generated SignedSource<<88b653cef555b9edfed7641bbd3fca87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingTitleAndXWCSwitcherOption_stream$data = {
  readonly account: {
    readonly id: string;
    readonly logo: string;
    readonly name: string;
  };
  readonly displayName: string;
  readonly id: string;
  readonly url: string | null;
  readonly " $fragmentType": "MeetingTitleAndXWCSwitcherOption_stream";
};
export type MeetingTitleAndXWCSwitcherOption_stream$key = {
  readonly " $data"?: MeetingTitleAndXWCSwitcherOption_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingTitleAndXWCSwitcherOption_stream">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingTitleAndXWCSwitcherOption_stream",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "97114f5cc7611e0fb98637636edb5dae";

export default node;
